<template>
    <div class="page" ref="page">
        <div class="top">
            <div class="title">
                <div class="l-top">当前套餐</div>
                <div class="r-top">{{ simInfo.pkgName }}</div>
            </div>
            <div class="liu">
                <div class="item">当前套餐<span>{{ fluxMtoG(simInfo.flowRate || 0) }}GB</span></div>
                <div class="item">已用流量<span>{{ fluxMtoG(simInfo.usedFlowRate || 0) }}GB</span></div>
                <div class="item">剩余流量<span>{{ fluxMtoG(simInfo.surplusFlowRate || 0) }}GB</span></div>
            </div>
        </div>
        <div class="user">
            <div class="logo">
                <img src="@/assets/userNew/icon23.png">
            </div>
            <div class="h5-name">
                <div class="name">Hi，{{ recordLoginText }}</div>
                <div class="status">
                    <div class="status-1">{{ simInfo.city }}</div>
                    <div class="status-1">网龄 {{ simInfo.simYear }}</div>
                    <div class="status-1" style="font-size: 10px;">
                        <img src="@/assets/new/25.png" alt="">
                        {{ simInfo.vipLever }}星
                    </div>
                    <div class="status-3">余额 {{ money_format(userSimAmount / 100, 2, ".", ",") * 1 }}元</div>
                </div>
            </div>
        </div>
        <div class="recommend" v-if="tuiObj && tuiObj.packageName">
            <div class="h5-t">
                <div class="title">{{ tuiObj.packageName }}</div>
                <div class="small">{{ tuiObj.remark }}</div>
                <div class="tiem">
                    <div class="l">享权益</div>
                    <div class="r">{{ tuiObj.sheRemark }}</div>
                </div>
            </div>
            <div class="btn-or-h">
                <div class="youhui">
                    <div class="price" v-if="tuiObj.sheMyPrice && tuiObj.sheMyPrice > 0">优惠价<span>{{ tuiObj.sheMyPrice }}</span>元/月
                    </div>
                    <div class="price" v-else>套餐价<span>{{ tuiObj.salePriceRmb }}</span>元</div>
                    <div class="y-price" v-if="tuiObj.sheOldPrice && tuiObj.sheOldPrice > 0 && tuiObj.sheMyPrice && tuiObj.sheMyPrice > 0">{{
                        tuiObj.sheOldPrice }}元/月</div>
                    <div class="y-price" v-else-if="tuiObj.sheOldPrice && tuiObj.sheOldPrice > 0">{{ tuiObj.sheOldPrice }}元</div>
                </div>
                <div class="btn" @click="handle(tuiObj)">
                    立即办理
                    <img src="@/assets/new/31.png" alt="">
                </div>
            </div>
            <div class="remark">推荐套餐</div>
        </div>

        <div class="box">更多套餐</div>

        <div class="recommend-fl" :style="{ 'height': allList.length > 4 && !isMore ? '908px' : 'auto' }">
            <div class="recommend-item" v-for="item in allList" :key="item.id">
                <div class="h5-t">
                    <div class="title">{{ item.packageName }}</div>
                    <div class="small">{{ item.remark }}</div>
                    <div class="tiem">
                        <div class="l" v-if="item.sheRemark">享权益</div>
                        <div class="r">{{ item.sheRemark }}</div>
                    </div>
                </div>
                <div class="btn-or-h">
                    <div class="youhui">
                        <div class="price" v-if="item.sheMyPrice && item.sheMyPrice > 0">优惠价<span>{{ item.sheMyPrice
                        }}</span>元/月</div>
                        <div class="price" v-else>套餐价<span>{{ item.salePriceRmb }}</span>元</div>
                        <div class="y-price"
                            v-if="item.sheOldPrice && item.sheOldPrice > 0 && item.sheMyPrice && item.sheMyPrice > 0">{{
                                item.sheOldPrice }}元/月</div>
                        <div class="y-price" v-else-if="item.sheOldPrice && item.sheOldPrice > 0">{{ item.sheOldPrice }}元</div>
                    </div>
                    <div class="btn" @click="handle(item)">
                        立即办理
                        <img src="@/assets/new/31.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="more-pack" v-if="allList.length > 4" @click="isMore = !isMore">
            {{ isMore ? '收起套餐' : '更多套餐' }}
            <img src="@/assets/new/30.png" alt="">
        </div>


        <div class="box">
            为你推荐
            <div class="small">充值余额可享受套餐折扣</div>
            <div class="more" @click="toInventSim()">
                更多
                <img src="@/assets/new/29.png" alt="">
            </div>
        </div>
        <van-swipe :loop="false" :width="126" :show-indicators="false">
            <van-swipe-item v-for="(item, index) in swipeList" :key="index"
                :class="{ 'swipe-item-action': currentIndex === index }" @click="change(item, index)">
                <div class="title">
                    <span>￥</span>{{ item.amount * 1 + item.giftBalance * 1 }}
                </div>
                <div class="small">{{ item.sysRemark }}</div>
                <div class="remark">{{ item.title }}</div>
                <div class="ft">
                    <div class="price">¥{{ item.amount }}</div>
                    <div class="discount">{{ item.zekou }}折</div>
                </div>
            </van-swipe-item>
        </van-swipe>

        <!--弹窗-->

        <div class="h5-dialog" :style="{ 'height': h_top + 'px' }" v-if="isShow1">
            <div class="content1">

            </div>
            <div class="close" style="top: calc(10% + 400px);">
                <img src="@/assets/new/35.png" alt="" @click="isShow1 = false">
            </div>
        </div>
        <van-dialog v-model="isShow" :showConfirmButton="false" class="dialog">
            <div class="title">{{ dataForm.myTitle }}</div>
            <div class="small-title">恭喜你成功领取套餐专属优惠卷</div>
            <div class="p">
                <div class="p-l"><span>￥</span>{{ dataForm.juanPrice }}</div>
                <div class="p-r">
                    <div class="t">优惠券</div>
                    <div class="b">{{ remaky }}</div>
                </div>
            </div>
            <div class="btn" @click="order">立即订购</div>
            <div class="close">
                <img src="@/assets/new/35.png" alt="" @click="isShow = false">
            </div>
        </van-dialog>
        <van-dialog v-model="isShow1" :showConfirmButton="false" class="dialog1">
            <div class="title">{{ dataForm.myTitle }}</div>
            <div class="small-title">套餐限时专享会员福利</div>
            <div class="p">
                <div class="p-l">+{{ dataForm.sheXuPrice }}<span>元</span></div>
                <div class="p-r">送{{ dataForm.sheXuDay }}天</div>
            </div>
            <div class="btn" @click="order">立即订购</div>
            <div class="close">
                <img src="@/assets/new/35.png" alt="" @click="isShow1 = false">
            </div>
        </van-dialog>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user.js'
import { Toast, Dialog } from 'vant';
export default {
    data() {
        return {
            userSimAmount: localStorage.getItem('userSimAmount'),
            recordLoginText: localStorage.getItem("recordLoginText"),
            h_top: 0,
            isShow: false,
            isShow1: false,
            tuiObj: {}, //推荐套餐
            allList: [],// 全部套餐
            isAdmin: '',
            setObj: {},
            isMore: false,
            dataForm: {},
            swipeList: [],
            currentIndex: null,
            remaky: "",
            simInfo: {},
            iccid: localStorage.getItem('iccid'),
        }
    },
    mounted() {
        wxRequest("sim/detail", { iccid: this.iccid }, "post").then(res => {
            if (res.data.code === '200') {
                this.simInfo = res.data.data;
            }
        })
        this.pkgInit()
    },
    methods: {
        toInventSim() {
            this.$router.push({
                path: "/new/balanceRecharge",
                query: {
                    iccid: this.iccid
                },
            });
        },
        pkgInit() {
            wxRequest("sim/user/soldPkg", { iccid: this.iccid }, "get").then(res => {
                if (res.data.code === '200') {
                    this.isAdmin = res.data.data.isAdmin
                    this.tuiObj = res.data.data.list.filter(item => item.sheTui === 1)[0]
                    if (this.tuiObj) {
                        this.allList = res.data.data.list.filter(item => item.id !== this.tuiObj.id).sort((b, a) => b.sort - a.sort);
                    } else {
                        this.allList = res.data.data.list.sort((b, a) => b.sort - a.sort);
                    }
                } else {
                    Toast(res.data.message)
                }
            })
            wxRequest("sim/uniorder/param", { iccid: this.iccid }, "post").then(res => {
                if (res.data.code === '200') {
                    this.swipeList = res.data.data.filter(item => item.type === 1)
                } else {
                    Toast(res.data.message)
                }
            })

        },
        //立即办理
        handle(row) {
            this.remaky = row.remark
            this.setObj = row
            wxRequest("she/select/auto/manager", { iccid: this.iccid, soldPackageId: row.id }, "post").then(res => {
                if (res.data.code === '200') {
                    this.dataForm = res.data.data
                    if (res.data.data.isShowtitle === 1) { // 显示弹窗1
                        this.isShow = true
                    } else if (res.data.data.isShowtitle === 2) {// 显示弹窗2
                        this.isShow1 = true
                    } else { //直接进入支付页面
                        var data = {
                            remark: this.setObj.remark,
                            sheRemark: this.setObj.sheRemark,
                            sheXuPrice: this.dataForm.sheXuPrice,
                            sheXuDay: this.dataForm.sheXuDay,
                            isAdmin: this.isAdmin,
                            iccid: this.iccid,
                            soldPackageId: row.id,
                            juanPrice: res.data.data.juanPrice,
                            sheVipKefu: res.data.data.sheVipKefu,
                            sheVipPrice: res.data.data.sheVipPrice,
                            salePriceRmb: this.setObj.salePriceRmb,
                            sheVipRemark: res.data.data.sheVipRemark,
                            isShowAddPkg: res.data.data.isShowAddPkg,
                            packageName: this.setObj.packageName
                        }
                        console.log(this.data)
                        this.$router.push({
                            path: "/new/payment",
                            query: {
                                p: encodeURIComponent(JSON.stringify(data)),
                            },
                        });
                    }
                } else {
                    Toast(res.data.message)
                }
            })

        },
        order() {
            var data = {
                remark: this.setObj.remark,
                sheXuPrice: this.dataForm.sheXuPrice,
                sheXuDay: this.dataForm.sheXuDay,
                sheRemark: this.setObj.sheRemark,
                isAdmin: this.isAdmin,
                iccid: this.iccid,
                soldPackageId: this.setObj.id,
                juanPrice: this.dataForm.juanPrice,
                sheVipKefu: this.dataForm.sheVipKefu,
                sheVipPrice: this.dataForm.sheVipPrice,
                salePriceRmb: this.setObj.salePriceRmb,
                sheVipRemark: this.dataForm.sheVipRemark,
                isShowAddPkg: this.dataForm.isShowAddPkg,
                packageName: this.setObj.packageName
            }
            this.$router.push({
                path: "/new/payment",
                query: {
                    p: encodeURIComponent(JSON.stringify(data)),
                },
            });
            this.isShow1 = false
            this.isShow = false
        },
        //滑动点击
        change(item, index) {
            var data = {
                iccid: this.iccid,
                amount: item.amount * 100,
                giftBalance: item.giftBalance,
                mobile: localStorage.getItem('userPhone'),
            }
            this.currentIndex = index;
            wxRequest('sim/get/pay/state', { iccid: this.iccid }, 'post').then(res => {
                if (res.data.code == 200) {
                    data.payType = 50;//乐刷
                } else if (res.data.code == 201) {
                    data.payType = 62;//云游
                } else {
                    data.payType = 20;//微信
                }
                wxRequest('order/user/create/investOrder', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        if (data.payType == 50) {
                            window.location.href = res.data.data.jspay_url;
                        } else if (data.payType == 62) {
                            window.location.href = res.data.data;
                        } else {
                            if (typeof WeixinJSBridge == "undefined") {
                                if (document.addEventListener) {
                                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                                } else if (document.attachEvent) {
                                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                                }
                            } else {
                                let param = res.data.data.param;
                                this.onBridgeReady(param);
                            }
                        }
                    } else {
                        Dialog.alert({ title: '提示', message: res.data.message });
                    }
                });


            });
        },

        onBridgeReady(param) {
            let _this = this;
            WeixinJSBridge.invoke('getBrandWCPayRequest', param, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    if (_this.$store.state.isNewPage == 1 || localStorage.getItem('isNewPage') == 1) {
                        _this.$router.push({
                            path: "/userNew/home",
                            query: {
                                iccid: _this.$store.state.iccid,
                            },
                        })
                            .catch(() => { });
                    } else if (_this.$store.state.isNewPage == 2 || localStorage.getItem('isNewPage') == 2) {
                        _this.$router
                            .push({
                                path: "/user/homeNew",
                                query: {
                                    iccid: _this.$store.state.iccid,
                                },
                            })
                            .catch(() => { });
                    } else if (_this.$store.state.isNewPage == 3 || localStorage.getItem('isNewPage') == 3) {
                        _this.$router
                            .push({
                                path: "/new/home",
                                query: {
                                    iccid: _this.$store.state.iccid,
                                },
                            })
                            .catch(() => { });
                    } else {
                        _this.$router
                            .push({
                                path: "/user/home",
                                query: {
                                    iccid: _this.$store.state.iccid,
                                },
                            })
                            .catch(() => { });
                    }
                }
            });
        },
    }
}
</script>
<style lang="less" scoped>
.page {
    width: 100%;
    background: linear-gradient(180deg, #9D5E25 0%, #FFEFE1 30%);
    padding-bottom: 30px;
    overflow-x: hidden;

    .top {
        height: 62px;
        background: url('~@/assets/new/23.png') no-repeat center;
        background-size: 100% 100%;

        .title {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 0 6px;

            .l-top {
                font-size: 16px;
                font-family: YouSheBiaoTiHei;
                background: linear-gradient(180deg, #FCD294 0%, #F7A65B 100%);
                -webkit-background-clip: text;
                background-clip: text;
                color: transparent;
                font-weight: bold;
                font-style: oblique;
                margin-right: 8px;
            }

            .r-top {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #FFEFE1;
                line-height: 20px;
            }
        }

        .liu {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: #fff;

            span {
                font-family: HarmonyOS_Sans_SC_Bold;
                font-weight: bold;
                padding: 0 10px 0 4px;
            }
        }
    }

    .user {
        margin: 18px 14px 20px;
        display: flex;
        align-items: center;

        .logo {
            width: 52px;
            height: 52px;
            margin-right: 11px;

            img {
                width: 100%;
                height: 100%;
                border-radius: 100%;
            }
        }

        .name {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 25px;
            margin-bottom: 4px;
        }

        .status {
            display: flex;
            align-items: center;

            .status-1 {
                color: #fff;
                font-family: PingFangSC, PingFang SC;
                font-size: 14px;
                background: #C18045;
                border-radius: 10px;
                padding: 4px 6px;
                margin-right: 5px;

                img {
                    width: 15px;
                    vertical-align: sub;
                    height: 15px;
                }
            }

            .status-3 {
                background: #F7A65B;
                border-radius: 10px;
                padding: 4px 6px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 10px;
                color: #FFFFFF;
                line-height: 14px;
            }
        }
    }

    .recommend {
        margin: 0 14px;
        background: url('~@/assets/new/24.png')no-repeat center;
        background-size: 100% 100%;
        padding: 10px;
        position: relative;

        .h5-t {
            border-radius: 10px;
            border: 1px solid #402A11;
            padding: 17px 13px 11px 16px;

            .title {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 16px;
                color: #FEF2DE;
                line-height: 22px;
                padding-bottom: 8px;
            }

            .small {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #A1642D;
                line-height: 20px;
            }

            .tiem {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 18px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #FFEFE1;
                line-height: 20px;

                .l {
                    background: #FF7C00;
                    border-radius: 4px;
                    padding: 6px 10px;
                }

                .r {
                    margin-left: 8px;
                }
            }
        }

        .btn-or-h {
            margin-top: 14px;
            height: 50px;
            border-radius: 26px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #FFEFE1;

            .youhui {
                text-align: center;
                width: 60%;

                .price {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #1D1B19;
                    line-height: 20px;

                    span {
                        font-size: 22px;
                        font-family: HarmonyOS_Sans_SC_Bold;
                        font-weight: bold;
                    }
                }

                .y-price {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 10px;
                    color: #9A9A9A;
                    line-height: 14px;
                    text-decoration-line: line-through;
                }
            }

            .btn {
                display: flex;
                background: #FF342C;
                font-family: PingFangSC, PingFang SC;
                justify-content: center;
                align-items: center;
                font-size: 18px;
                color: #FFEFE1;
                width: 40%;
                height: 100%;
                border-radius: 0px 26px 26px 0px;

                img {
                    width: 8px;
                    margin-left: 9px;
                    height: 14px;
                }
            }
        }

        .remark {
            position: absolute;
            left: 0;
            top: -10px;
            height: 26px;
            width: 70px;
            text-align: center;
            line-height: 22px;
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #FFEFE1;
            background: url('~@/assets/new/28.png') no-repeat center;
            background-size: 100% 100%;
        }
    }

    .box {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #1D1B19;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        margin-top: 22px;
        margin-left: 14px;
        display: flex;
        align-items: center;

        .small {
            width: 60%;
            margin-left: 5px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #908B85;
            line-height: 20px;
        }

        .more {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #908B85;
            line-height: 20px;

            img {
                width: 8px;
                height: 14px;
                margin-left: 5px;
            }
        }
    }

    .recommend-fl {
        margin: 0 14px;
        overflow: hidden;

        .recommend-item {
            box-shadow: 0px 0px 8px 0px #EFD0B5;
            background: #FFFFFF;
            border-radius: 10px;
            padding: 10px 10px 13px;
            margin-top: 10px;

            .h5-t {
                border-radius: 10px;
                background: url('~@/assets/new/26.png') no-repeat;
                background-size: 100% 100%;
                padding: 17px 13px 11px 16px;

                .title {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 16px;
                    color: #1D1B19;
                    line-height: 22px;
                    padding-bottom: 8px;
                }

                .small {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #908B85;
                    line-height: 20px;
                }

                .tiem {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 18px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #FFEFE1;
                    line-height: 20px;

                    .l {
                        background: #FF7C00;
                        border-radius: 4px;
                        padding: 6px 10px;
                    }

                    .r {
                        color: #FF7C00;
                        margin-left: 8px;
                    }
                }
            }

            .btn-or-h {
                margin-top: 14px;
                height: 50px;
                border-radius: 26px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: #FFEFE1;

                .youhui {
                    text-align: center;
                    width: 60%;

                    .price {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #1D1B19;
                        line-height: 20px;

                        span {
                            font-size: 22px;
                            font-family: HarmonyOS_Sans_SC_Bold;
                            font-weight: bold;
                        }
                    }

                    .y-price {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 10px;
                        color: #9A9A9A;
                        line-height: 14px;
                        text-decoration-line: line-through;
                    }
                }

                .btn {
                    display: flex;
                    background: #31220F;
                    font-family: PingFangSC, PingFang SC;
                    justify-content: center;
                    align-items: center;
                    font-size: 18px;
                    color: #FFEFE1;
                    width: 40%;
                    height: 100%;
                    border-radius: 0px 26px 26px 0px;

                    img {
                        width: 8px;
                        margin-left: 9px;
                        height: 14px;
                    }
                }
            }
        }
    }

    .more-pack {
        margin: 14px auto;
        text-align: center;
        width: 156px;
        height: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #908B85;
        line-height: 20px;

        img {
            width: 14px;
            height: 8px;
        }
    }

    .van-swipe {
        margin: 25px 0 0 14px;
        overflow: unset;

        .van-swipe-item {
            margin-right: 10px;
            height: 154px;
            background-color: #fff;
            box-shadow: 0px 0px 8px 0px #EFD0B5;
            border-radius: 10px;
            border: 1px solid #fff;
            position: relative;

            .title {
                font-family: HarmonyOS_Sans_SC_Bold;
                font-size: 28px;
                font-weight: bold;
                color: #C47A3A;
                line-height: 40px;
                margin-top: 18px;
                text-align: center;

                span {
                    font-size: 14px;
                    font-weight: normal;
                }
            }

            .small {
                margin: 6px 10px 21px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 11px;
                color: #908B85;
                line-height: 16px;
            }

            .ft {
                display: flex;
                align-items: center;
                height: 36px;
                background: #C47A3A;
                border-radius: 0px 0px 10px 10px;
                justify-content: center;

                .price {
                    font-family: HarmonyOS_Sans_SC_Medium;
                    font-size: 20px;
                    color: #FFFFFF;
                    line-height: 29px;
                    font-weight: bold;
                }

                .discount {
                    height: 17px;
                    background: RGBA(213, 162, 117, .3);
                    border-radius: 9px;
                    color: #FFFFFF;
                    font-size: 10px;
                    font-family: PingFangSC, PingFang SC;
                    line-height: 16px;
                    margin-left: 5px;
                    padding: 2px 6px;
                }
            }

            .remark {
                position: absolute;
                background: linear-gradient(270deg, #FFCC96 0%, #E1AB7E 100%);
                border-radius: 15px;
                left: 0;
                right: 0;
                text-align: center;
                height: 26px;
                line-height: 26px;
                font-weight: 400;
                font-family: PingFangSC, PingFang SC;
                font-size: 14px;
                color: #FFFFFF;
                top: -10px;
                margin: auto;
                width: 70%;
            }

            &:nth-child(1) {
                .remark {
                    background: linear-gradient(270deg, #FFB300 0%, #C47A3A 100%);
                }
            }
        }

        .swipe-item-action {
            border: 1px solid #FF7C00;
            background: #FFF2E5;
        }
    }

    .van-dialog {
        top: 40%;
        background: none;
        overflow: unset;
    }

    .dialog ::v-deep .van-dialog__content {
        margin: 0 auto;
        height: 487px;
        background: url('~@/assets/new/33.png')no-repeat center;
        background-size: 100% 100%;
        position: relative;

        .title {
            font-family: HarmonyOS_Sans_SC_Black;
            font-size: 28px;
            line-height: 40px;
            text-align: left;
            background: linear-gradient(90deg, #FF7D2D 0%, #FF280F 100%);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            font-weight: bold;
            padding-top: 190px;
            text-align: center;
        }

        .small-title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #D9381F;
            line-height: 20px;
            margin-top: 8px;
            text-align: center;
            position: relative;

            &::before {
                content: '';
                background: linear-gradient(243deg, rgba(255, 248, 241, 1), rgba(255, 40, 15, 1));
                width: 18px;
                height: 2px;
                position: absolute;
                display: block;
                top: 9px;
                right: 30px;
            }

            &::after {
                content: '';
                background: linear-gradient(243deg, rgba(255, 40, 15, 1), rgba(255, 248, 241, 1));
                width: 18px;
                height: 2px;
                position: absolute;
                display: block;
                top: 9px;
                left: 30px;
            }
        }

        .p {
            margin: 27px 37px;
            background: url('~@/assets/new/34.png')no-repeat center;
            background-size: 100% 100%;
            display: flex;
            height: 80px;
            align-items: center;

            .p-l {
                width: 50%;
                text-align: center;
                font-family: HarmonyOS_Sans_SC_Bold;
                font-size: 30px;
                line-height: 42px;
                background: linear-gradient(180deg, #FFFFFF 0%, #FFDB78 100%);
                -webkit-background-clip: text;
                background-clip: text;
                color: transparent;
                font-weight: bold;

                span {
                    font-family: HarmonyOS_Sans_SC;
                    font-size: 12px;
                    color: #FFEAB2;
                    font-weight: normal;
                    line-height: 17px;
                }
            }

            .p-r {
                padding-left: 14px;

                .t {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 16px;
                    color: #FFFFFF;
                    line-height: 22px;
                }

                .b {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 12px;
                    color: #FFECB6;
                    line-height: 15px;
                }
            }
        }

        .btn {
            width: 178px;
            margin: 0 auto;
            height: 44px;
            line-height: 44px;
            text-align: center;
            color: #fff;
            font-weight: 500;
            font-family: PingFangSC, PingFang SC;
            font-size: 20px;
            background: url('~@/assets/new/32.png') no-repeat center;
            background-size: 100% 100%;
        }

        .close {
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            text-align: center;
            top: 110%;
            z-index: 9999;

            img {
                width: 26px;
                height: 26px;
            }
        }


    }

    .dialog1 {
        width: 100%;

        ::v-deep .van-dialog__content {
            height: 454px;
            background: url('~@/assets/new/36.png')no-repeat center;
            background-size: 100% 100%;
            width: 100%;
            position: relative;

            .title {
                height: 40px;
                font-family: HarmonyOS_Sans_SC_Black;
                font-size: 28px;
                color: #832604;
                line-height: 40px;
                font-weight: bold;
                text-align: center;
                padding-top: 108px;

                span {
                    color: #FD5A56;
                }
            }

            .small-title {
                width: 224px;
                margin: auto;
                margin-top: 6px;
                text-align: center;
                background: url('~@/assets/new/38.png')no-repeat center;
                background-size: 100% 3px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #842706;
                line-height: 20px;
            }

            .p {
                margin: auto;
                margin-top: 58px;
                display: flex;
                width: 224px;

                .p-l {
                    width: 50%;
                    font-size: 34px;
                    font-family: HarmonyOS_Sans_SC_Black;
                    color: #FFFFFF;
                    font-weight: bold;

                    span {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                    }
                }

                .p-r {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 24px;
                    color: #FFFFFF;
                    line-height: 33px;
                }
            }

            .btn {
                width: 178px;
                margin: 0 auto;
                height: 54px;
                line-height: 54px;
                text-align: center;
                color: #fff;
                font-weight: 500;
                font-family: PingFangSC, PingFang SC;
                font-size: 20px;
                background: url('~@/assets/new/37.png') no-repeat center;
                background-size: 100% 100%;
                margin-top: 28px;
            }

            .close {
                position: absolute;
                left: 0;
                right: 0;
                margin: 0 auto;
                text-align: center;
                top: 100%;
                z-index: 9999;

                img {
                    width: 26px;
                    height: 26px;
                }
            }
        }
    }
}</style>